/**
 * `crypto.randomUUID` is only exposed in secure contexts (HTTPS /
 * localhost), so calling it directly crashes checkout on the local
 * `http://*.mld.test` dev stack.  `crypto.getRandomValues` has no such
 * restriction, so fall back to building an RFC 4122 v4 UUID from it.
 */
export function randomUUID(): string {
    if (typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
    bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10xx
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
